module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0001_reset_password")]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form1 col-xs-3",
    staticStyle: {
      "margin-left": "-15px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form1 col-xs-6",
    staticStyle: {
      "margin-left": "-15px"
    }
  }, [_c('title-and-slot', {
    attrs: {
      "title": "PWロック解除"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }), _vm._v(" "), _c('br')], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form1 col-xs-3",
    staticStyle: {
      "margin": "-5px 15px 15px -15px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form1 col-xs-6",
    staticStyle: {
      "margin": "-5px 15px 15px -15px"
    }
  }, [_vm._v("\n          ライセンス管理窓口にて内容を確認後、パスワードロック解除を行います。"), _c('br'), _vm._v("\n          作業後にご連絡いたしますので、速やかにログインできることをご確認頂きますようお願いいたします。"), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "float": "left",
      "min-width": "130px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("戻る")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    staticStyle: {
      "float": "right",
      "min-width": "130px"
    },
    attrs: {
      "disabled": _vm.disallowToSubmit
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("申請")])])])]), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "ResetPasswordModal"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "color": "#FFFFFF",
      "font-size": "30px",
      "padding": "27px 50px",
      "font-weight": "800",
      "background": "#5b9bd5"
    }
  }, [_vm._v("\n      ソフトウェアライセンス管理\n      "), _c('br'), _c('div', {
    staticStyle: {
      "font-size": "20px",
      "color": "#FFFFFF"
    }
  }, [_vm._v("e-sma")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bd2a786","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/page_0001_reset_password.vue
// module id = 954
// module chunks = 0